import { JournalEntry } from "shared/request/myHealthyAdvantageApi";

export const getSurroundingEntries = (
  entries: JournalEntry[],
  currentEntryId: string
): JournalEntry[] => {
  const currentIndex = entries.findIndex(
    entry => entry.id === currentEntryId
  );

  if (currentIndex === -1) {
    return [];
  }

  const previousEntries = entries.slice(0, currentIndex).reverse();

  const futureEntries = entries.slice(currentIndex + 1);

  const surroundingEntries = previousEntries.slice(0, 3);

  if (surroundingEntries.length < 3) {
    surroundingEntries.push(
      ...futureEntries.slice(
        0,
        3 - surroundingEntries.length
      )
    );
  }

  return surroundingEntries;
};

